import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const onboardingHubEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(/* webpackChunkName: "async-onboarding-hub" */ './src/ui/index.tsx').then(
			(module) => module.OnboardingHubPage,
		),
	),
	getPreloadProps: () => ({}),
});
